import { SVGFC } from '@repo/toolkit/types'

const PlusIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.75 8.25C2.75 8.03089 2.83704 7.82075 2.99198 7.66582C3.14691 7.51089 3.35705 7.42384 3.57616 7.42384H7.42384V3.57616C7.42384 3.35705 7.51089 3.14691 7.66582 2.99198C7.82075 2.83704 8.03089 2.75 8.25 2.75C8.46911 2.75 8.67925 2.83704 8.83418 2.99198C8.98912 3.14691 9.07616 3.35705 9.07616 3.57616V7.42384H12.9238C13.143 7.42384 13.3531 7.51089 13.508 7.66582C13.663 7.82075 13.75 8.03089 13.75 8.25C13.75 8.46911 13.663 8.67925 13.508 8.83418C13.3531 8.98912 13.143 9.07616 12.9238 9.07616H9.07616V12.9238C9.07616 13.143 8.98912 13.3531 8.83418 13.508C8.67925 13.663 8.46911 13.75 8.25 13.75C8.03089 13.75 7.82075 13.663 7.66582 13.508C7.51089 13.3531 7.42384 13.143 7.42384 12.9238V9.07616H3.57616C3.35705 9.07616 3.14691 8.98912 2.99198 8.83418C2.83704 8.67925 2.75 8.46911 2.75 8.25Z"
        fill={color}
      />
    </svg>
  )
}

export default PlusIcon
